import { render, staticRenderFns } from "./tab-intro.vue?vue&type=template&id=6e945663&scoped=true&"
import script from "./tab-intro.vue?vue&type=script&lang=js&"
export * from "./tab-intro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e945663",
  null
  
)

export default component.exports